import { ConsumableData } from "../types/ConsumableData";
import {StagingTitelineAppConsumable} from "../types/StagingTitelineAppConsumable";
import { getApiUrl } from '../config/api';

export const fetchConsumableByPid = async (pid?: number, aid: number = -1): Promise<ConsumableData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineConsumable/GetConsumableByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No consumables found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching consumables for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppConsumable[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((consumable) => consumable.DataSource === aid.toString());
        }

        return backendData.map((consumable) => ({
            key: consumable.ConsId,
            cons_id: consumable.ConsId,
            pid: consumable.Pid,
            hole_id: consumable.HoleID,
            item: consumable.Item,
            quantity: consumable.Quantity,
        }));
    } catch (error) {
        console.error("Error in fetchConsumableByPid API call:", error);
        return [];
    }
};

export const addConsumableRow = async (consumableRow: ConsumableData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineConsumable/AddConsumable');

    const cloudPayload = [
        {
            Pid: consumableRow.pid ?? -1,
            HoleID: consumableRow.hole_id,
            Item: consumableRow.item,
            Quantity: consumableRow.quantity,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Consumable row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add consumable row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addConsumableRow API call:", error);
        return false;
    }
};

export const updateConsumableRow = async (cons_id: number, updatedRow: ConsumableData) => {
    const apiUrl = getApiUrl(`/api/TitelineConsumable/UpdateConsumableByConsid/${cons_id}`);
    const cloudPayload = {
        HoleID: updatedRow.hole_id,
        Item: updatedRow.item,
        Quantity: updatedRow.quantity,
    };

    console.log("cloudPayload:", cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Consumable row with ConsId ${cons_id} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update consumable row with ConsId ${cons_id}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateConsumableRow API call:", error);
        return false;
    }
};

export const deleteConsumableByConsId = async (cons_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelineConsumable/DeleteConsumableByConsid/${cons_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteConsumablesByConsId API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete consumable row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteConsumableByConsid API call:", error);
        return false;
    }
};